import { GET_ACCOUNT_INFO, GET_ACCOUNT_INFO_SUCCESS, GET_ACCOUNT_INFO_ERROR, GET_SUBSCRIPTIONS, GET_SUBSCRIPTIONS_SUCCESS, GET_SUBSCRIPTIONS_ERROR, GET_USERS, GET_USERS_SUCCESS, GET_USERS_ERROR, GET_DASHBOARD_SUCCESS, GET_DASHBOARD_ERROR, ADD_DASHBOARD_ITEM_SUCCESS, ADD_DASHBOARD_ITEM_ERROR, DELETE_DASHBOARD_ITEM_SUCCESS, DELETE_DASHBOARD_ITEM_ERROR} from "./actionTypes"

const initialState = {
  users: [],
  subscriptions: [],
  dashboard: [],
  session: "",
  error: "",
  success: "",
}

const admin = (state = initialState, action) => {
  switch (action.type) {
    case GET_USERS:
      state = { ...state }
      break
    case GET_ACCOUNT_INFO:
      state = { ...state }
      break
    case GET_SUBSCRIPTIONS:
      state = { ...state }
      break
    case GET_USERS_SUCCESS:
      state = { ...state, users: action.payload }
      break
    case GET_ACCOUNT_INFO_SUCCESS:
      state = { ...state, session: action.payload }
      break
    case GET_SUBSCRIPTIONS_SUCCESS:
      state = { ...state, subscriptions: action.payload }
      break
    case GET_USERS_ERROR:
      state = { ...state, error: action.payload }
      break
    case GET_SUBSCRIPTIONS_ERROR:
      state = { ...state, error: action.payload }
      break
    case GET_ACCOUNT_INFO_ERROR:
      state = { ...state, error: action.payload }
      break
    case GET_DASHBOARD_SUCCESS:
      console.log(action.payload)
      return {
        ...state,
        dashboard: action.payload,
      }
    case ADD_DASHBOARD_ITEM_SUCCESS:
      state = { ...state, dashboard: action.payload }
      break
    case DELETE_DASHBOARD_ITEM_SUCCESS:
      state = { ...state, dashboard: action.payload }
      break
    case GET_DASHBOARD_ERROR:
      state = { ...state, error: action.payload }
      break
    case ADD_DASHBOARD_ITEM_ERROR:
      state = { ...state, error: action.payload }
      break
    case DELETE_DASHBOARD_ITEM_ERROR:
      state = { ...state, error: action.payload }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default admin 
